import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

class PdfFooter extends Component {
	render() {
		return (
			<div className="results-document-layout-footer">
				{this.props.children}
			</div>
		);
	}
}
PdfFooter.propTypes = {
	children: PropTypes.node
};
export default PdfFooter;
